const routes = [
  {
    path: 'vform',
    name: 'vform',
    component: () => import(/* webpackChunkName: "vform" */ '@/modules/vform/index.vue')
  },
];

export default routes;